import { gql } from 'apollo-boost';

export const GROUP_NAME_LIST_FRAGMENT = gql`
    fragment GroupNameList on Group {
        id,
        name
    }
`;
